module.exports = __webpack_public_path__ + "static/media/3.5aa204d9.JPG";